import Corporation         from "../../../domain/corporation/Corporation";
import CorporationName     from "../../../domain/corporation/CorporationName";
import CorporationNameKana from "../../../domain/corporation/CorporationNameKana";
import Building            from "../../../domain/fundamentals/address/Building";
import City                from "../../../domain/fundamentals/address/City";
import PostalCode          from "../../../domain/fundamentals/address/PostalCode";
import Prefecture          from "../../../domain/fundamentals/address/Prefecture";
import Street              from "../../../domain/fundamentals/address/Street";
import Email               from "../../../domain/fundamentals/email/Email";
import FirstName           from "../../../domain/fundamentals/name/FirstName";
import FirstNameKana       from "../../../domain/fundamentals/name/FirstNameKana";
import LastName            from "../../../domain/fundamentals/name/LastName";
import LastNameKana        from "../../../domain/fundamentals/name/LastNameKana";
import Phone               from "../../../domain/fundamentals/phone/Phone";
import ResKaReduxAction    from "../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_CORPORATION = "SET_CORPORATION",
  SET_CORPORATION_NAME = "SET_CORPORATION_NAME",
  SET_CORPORATION_NAME_KANA = "SET_CORPORATION_NAME_KANA",
  SET_CORPORATION_PHONE = "SET_CORPORATION_PHONE",
  SET_CORPORATION_APPLICANT_LAST_NAME = "SET_CORPORATION_APPLICANT_LAST_NAME",
  SET_CORPORATION_APPLICANT_FIRST_NAME = "SET_CORPORATION_APPLICANT_FIRST_NAME",
  SET_CORPORATION_APPLICANT_LAST_NAME_KANA = "SET_CORPORATION_APPLICANT_LAST_NAME_KANA",
  SET_CORPORATION_APPLICANT_FIRST_NAME_KANA = "SET_CORPORATION_APPLICANT_FIRST_NAME_KANA",
  SET_CORPORATION_APPLICANT_EMAIL = "SET_CORPORATION_APPLICANT_EMAIL",
  SET_CORPORATION_ADDRESS_POSTAL_CODE = "SET_CORPORATION_ADDRESS_POSTAL_CODE",
  SET_CORPORATION_ADDRESS_PREFECTURE = "SET_CORPORATION_ADDRESS_PREFECTURE",
  SET_CORPORATION_ADDRESS_CITY = "SET_CORPORATION_ADDRESS_CITY",
  SET_CORPORATION_ADDRESS_STREET = "SET_CORPORATION_ADDRESS_STREET",
  SET_CORPORATION_ADDRESS_BUILDING = "SET_CORPORATION_ADDRESS_BUILDING",
}

export interface SetCorporationAction extends ResKaReduxAction {
  corporation: Corporation;
}

export interface SetCorporationNameAction extends ResKaReduxAction {
  name: CorporationName;
}

export interface SetCorporationNameKanaAction extends ResKaReduxAction {
  nameKana: CorporationNameKana;
}

export interface SetCorporationPhoneAction extends ResKaReduxAction {
  phone: Phone;
}

export interface SetCorporationApplicantLastNameAction extends ResKaReduxAction {
  lastName: LastName;
}

export interface SetCorporationApplicantFirstNameAction extends ResKaReduxAction {
  firstName: FirstName;
}

export interface SetCorporationApplicantLastNameKanaAction extends ResKaReduxAction {
  lastNameKana: LastNameKana;
}

export interface SetCorporationApplicantFirstNameKanaAction extends ResKaReduxAction {
  firstNameKana: FirstNameKana;
}

export interface SetCorporationApplicantEmailAction extends ResKaReduxAction {
  email: Email;
}

export interface SetCorporationAddressPostalCodeAction extends ResKaReduxAction {
  postalCode: PostalCode;
}

export interface SetCorporationAddressPrefectureAction extends ResKaReduxAction {
  prefecture: Prefecture;
}

export interface SetCorporationAddressCityAction extends ResKaReduxAction {
  city: City;
}

export interface SetCorporationAddressStreetAction extends ResKaReduxAction {
  street: Street;
}

export interface SetCorporationAddressBuildingAction extends ResKaReduxAction {
  building: Building;
}

export type CorporationAction =
  SetCorporationAction
  | SetCorporationNameAction
  | SetCorporationNameKanaAction
  | SetCorporationPhoneAction
  | SetCorporationApplicantLastNameAction
  | SetCorporationApplicantFirstNameAction
  | SetCorporationApplicantLastNameKanaAction
  | SetCorporationApplicantFirstNameKanaAction
  | SetCorporationApplicantEmailAction
  | SetCorporationAddressPostalCodeAction
  | SetCorporationAddressPrefectureAction
  | SetCorporationAddressCityAction
  | SetCorporationAddressStreetAction
  | SetCorporationAddressBuildingAction
  ;

export const setCorporationAction = (corporation: Corporation): SetCorporationAction => ({
  type: ACTION_TYPE.SET_CORPORATION,
  corporation: corporation,
});

export const setCorporationNameAction = (name: CorporationName): SetCorporationNameAction => ({
  type: ACTION_TYPE.SET_CORPORATION_NAME,
  name: name,
});

export const setCorporationNameKanaAction = (nameKana: CorporationNameKana): SetCorporationNameKanaAction => ({
  type: ACTION_TYPE.SET_CORPORATION_NAME_KANA,
  nameKana: nameKana,
});

export const setCorporationPhoneAction = (phone: Phone): SetCorporationPhoneAction => ({
  type: ACTION_TYPE.SET_CORPORATION_PHONE,
  phone: phone,
});

export const setCorporationApplicantLastNameAction = (lastName: LastName): SetCorporationApplicantLastNameAction => ({
  type: ACTION_TYPE.SET_CORPORATION_APPLICANT_LAST_NAME,
  lastName: lastName,
});

export const setCorporationApplicantFirstNameAction = (firstName: FirstName): SetCorporationApplicantFirstNameAction => ({
  type: ACTION_TYPE.SET_CORPORATION_APPLICANT_FIRST_NAME,
  firstName: firstName,
});

export const setCorporationApplicantLastNameKanaAction = (lastNameKana: LastNameKana): SetCorporationApplicantLastNameKanaAction => ({
  type: ACTION_TYPE.SET_CORPORATION_APPLICANT_LAST_NAME_KANA,
  lastNameKana: lastNameKana,
});

export const setCorporationApplicantFirstNameKanaAction = (firstNameKana: FirstNameKana): SetCorporationApplicantFirstNameKanaAction => ({
  type: ACTION_TYPE.SET_CORPORATION_APPLICANT_FIRST_NAME_KANA,
  firstNameKana: firstNameKana,
});

export const setCorporationApplicantEmailAction = (email: Email): SetCorporationApplicantEmailAction => ({
  type: ACTION_TYPE.SET_CORPORATION_APPLICANT_EMAIL,
  email: email,
});

export const setCorporationAddressPostalCodeAction = (postalCode: PostalCode): SetCorporationAddressPostalCodeAction => ({
  type: ACTION_TYPE.SET_CORPORATION_ADDRESS_POSTAL_CODE,
  postalCode: postalCode,
});

export const setCorporationAddressPrefectureAction = (prefecture: Prefecture): SetCorporationAddressPrefectureAction => ({
  type: ACTION_TYPE.SET_CORPORATION_ADDRESS_PREFECTURE,
  prefecture: prefecture,
});

export const setCorporationAddressCityAction = (city: City): SetCorporationAddressCityAction => ({
  type: ACTION_TYPE.SET_CORPORATION_ADDRESS_CITY,
  city: city,
});

export const setCorporationAddressStreetAction = (street: Street): SetCorporationAddressStreetAction => ({
  type: ACTION_TYPE.SET_CORPORATION_ADDRESS_STREET,
  street: street,
});

export const setCorporationAddressBuildingAction = (building: Building): SetCorporationAddressBuildingAction => ({
  type: ACTION_TYPE.SET_CORPORATION_ADDRESS_BUILDING,
  building: building,
});
